<ng-container *ngIf="!!get && statuses.length > 0">
    <!-- <tt-tabs ttRememberId="w_cuttingplan.cuttingplanstatus_no" [(ttSelectedId)]="get.cuttingplanstatus_no">
        <tt-tab *ngIf="'' + get.cuttingplanstatus_no === '10'" ttId="SCAN" ttLabel="cuttingplanstatus_no_scan"></tt-tab>
        <tt-tab ttId="BASIS" ttLabel="cuttingplanstatus_no_basis"></tt-tab>
        <tt-tab ttId="POS" ttLabel="cuttingplanstatus_no_pos"></tt-tab>
    </tt-tabs> -->

    <tt-tabs [(ttSelectedId)]="get.cuttingplanstatus_no" ttAutoSelectFirst="false">
        <ng-container *ngFor="let status of statuses">
            <tt-tab [ttId]="status.item_id" [ttLabel]="status.item_name" ttTranslateLabel="false" [ttDisabled]="status.item_id !== get.cuttingplanstatus_no"></tt-tab>
        </ng-container>
    </tt-tabs>
    <!-- 
    <div style="float: left; width: 100%">
        <tt-card class="col-xs-12 col-md-9 sp-0" style="padding-bottom: 5px">
            <div class="col-xs-12 sp-0" style="display: flex; align-items: flex-end">
                <tt-button
                    class="col-md-4 col-xs-12 sp-5"
                    ttText="cuttingplan_previous"
                    ttType="secondary"
                    (ttClick)="previousStep()"
                    [ttLoading]="steppingPrevious"
                    [ttDisabled]="'' + get.cuttingplanstatus_no === '10' || steppingNext"
                ></tt-button>
                <tt-button
                    class="col-md-4 col-xs-12 sp-5"
                    ttText="cuttingplan_next"
                    (ttClick)="nextStep()"
                    [ttLoading]="steppingNext"
                    [ttDisabled]="'' + get.cuttingplanstatus_no === '60' || steppingPrevious"
                ></tt-button>
                <tt-input-number
                    class="col-md-4 col-xs-12 sp-5"
                    ttLabelView="top"
                    ttLabel="stock_stockvalue_ex_assigned"
                    [(ttModel)]="get.stock_stockvalue_ex_assigned"
                    (ttModelChange)="onChange('stock_stockvalue_ex_assigned')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                >
                    <ng-container buttons>
                        <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="stockget" [ttGotoParms]="{ stock_keyno: '' + get.stock_keyno }"></tt-form-field-button>
                    </ng-container>
                </tt-input-number>
            </div>
        </tt-card>
    </div> -->
    <!-- 
    <tt-card [hidden]="get.cuttingplanstatus_no !== 'SCAN'">
        <tt-input ttLabelView="top" ttLabel="barcode" [(ttModel)]="get.barcode" (ttModelChange)="onScan()" ttBindFocus ttDebounceTime="500"></tt-input>
        <tt-toast *ngIf="!!scan" [ttTitle]="scan.errormessage" ttTranslateTitle="false" [ttType]="'' + scan.errorcode !== '0' ? 'danger' : 'success'"></tt-toast>
    </tt-card> -->

    <div [hidden]="get.cuttingplanstatus_no !== '10'">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="previousButton"></ng-container>
                <tt-input ttLabelView="top" ttLabel="cuttingplan_keyno" [(ttModel)]="get.cuttingplan_keyno" ttReadonly></tt-input>
                <tt-input ttLabelView="top" ttLabel="cuttingplan_name" [(ttModel)]="get.cuttingplan_name" (ttModelChange)="onChange('cuttingplan_name')"></tt-input>
                <tt-select
                    ttRememberId="w_cuttingplan.businessco_no"
                    ttLabelView="top"
                    ttLabel="businessco"
                    [(ttModel)]="get.businessco_no"
                    (ttModelChange)="onBusinessCoChanged()"
                    [ttData]="companies"
                    ttDataId="businessco_no"
                    ttDataName="company_name"
                ></tt-select>
                <tt-select
                    ttRememberId="w_cuttingplan.factory_id"
                    ttLabelView="top"
                    ttLabel="factory"
                    [(ttModel)]="get.factory_id"
                    (ttModelChange)="onFactoryChanged()"
                    [ttData]="factories"
                    ttDataId="factory_id"
                    ttDataName="factory_name"
                ></tt-select>
                <tt-select
                    ttRememberId="w_cuttingplan.stockplace_id"
                    ttLabelView="top"
                    ttLabel="stockplace"
                    [(ttModel)]="get.stockplace_id"
                    (ttModelChange)="onChange('stockplace_id')"
                    [ttData]="stockplaces"
                    ttDataId="stockplace_id"
                    ttDataName="stockplace_name"
                    [ttReadonly]="'' + get.cuttingplanstatus_no !== '10'"
                ></tt-select>
                <tt-select
                    ttRememberId="w_cuttingplan.workgrp_keyno"
                    ttLabelView="top"
                    ttLabel="workgrp"
                    [(ttModel)]="get.workgrp_keyno"
                    (ttModelChange)="onWorkGroupChanged()"
                    [ttData]="workgroups"
                    ttDataId="workgrp_keyno"
                    ttDataName="workgrp_name"
                ></tt-select>
                <tt-select
                    ttRememberId="w_cuttingplan.equipment_id"
                    ttLabelView="top"
                    ttLabel="equipment"
                    [(ttModel)]="get.equipment_id"
                    (ttModelChange)="onEquipmentChanged()"
                    [ttData]="equipments"
                    ttDataId="item_id"
                    ttDataName="item_name"
                ></tt-select>
                <tt-select
                    ttRememberId="w_cuttingplan.operation_id"
                    ttLabelView="top"
                    ttLabel="operation"
                    [(ttModel)]="get.operation_id"
                    (ttModelChange)="onChange('operation_id')"
                    [ttData]="operations"
                    ttDataId="item_id"
                    ttDataName="item_name"
                    [ttReadonly]="'' + get.cuttingplanstatus_no !== '10'"
                ></tt-select>
            </tt-card>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="nextButton"></ng-container>

                <!-- <tt-search
                    ttLabelView="top"
                    ttLabel="prod"
                    [(ttModel)]="$any(get).prod_keyname"
                    [ttSearch]="searchProducts"
                    ttDataId="prod_id"
                    ttDataName="prod_keyname"
                    (ttOnSelected)="onProductSelected($event)"
                    (ttOnClear)="onProductSelected()"
                    ttMinLength="0"
                    [ttReadonly]="'' + get.cuttingplanstatus_no !== '10'"
                >
                </tt-search> -->
                <tt-input ttLabelView="top" ttLabel="prod_id_undefined_format" [(ttModel)]="get.prod_id_undefined_format" ttReadonly></tt-input>
                <tt-search
                    ttLabelView="top"
                    ttLabel="prod_name_undefined_format"
                    [(ttModel)]="get.prod_name_undefined_format"
                    [ttSearch]="searchProducts"
                    ttDataId="prod_id"
                    ttDataName="prod_keyname"
                    (ttOnSelected)="onProductSelected($event)"
                    (ttOnClear)="onProductSelected()"
                    ttMinLength="0"
                    ttListboxMaxHeight="min(500px, 50%)"
                    [ttReadonly]="'' + get.cuttingplanstatus_no !== '10'"
                ></tt-search>
                <tt-input ttLabelView="top" ttLabel="prod_id_defined_format" [(ttModel)]="get.prod_id" ttReadonly></tt-input>
                <!-- <tt-input ttLabelView="top" ttLabel="prod_name" [(ttModel)]="get.prod_name" ttReadonly></tt-input> -->
                <tt-select
                    ttRememberId="w_cuttingplan.prod_id"
                    ttLabelView="top"
                    ttLabel="prod_name_defined_format"
                    [(ttModel)]="get.prod_id"
                    (ttModelChange)="onChange('prod_id')"
                    (ttSelect)="onComponentAlternativeSelected($event)"
                    [ttData]="formats"
                    ttDataId="prod_id"
                    ttDataName="prod_name"
                    [ttReadonly]="'' + get.cuttingplanstatus_no !== '10'"
                ></tt-select>
            </tt-card>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="gotoStockButton"></ng-container>

                <!-- <tt-select ttLabelView="top" ttLabel="printer" [(ttModel)]="$any(get).printer_keyno" [ttData]="printers" ttDataId="printClientPrinterKeyno" ttDataName="name"></tt-select> -->
            </tt-card>
        </div>

        <tt-card>
            <!-- <tt-button-save *ngIf="'' + get.cuttingplanstatus_no === '10'" ttText="cuttingplan_save" (ttClick)="save()" [ttLoading]="saving"></tt-button-save> -->
            <tt-button-settings *ngIf="get.show_setting === '1'"></tt-button-settings>
        </tt-card>
    </div>
    <div [hidden]="get.cuttingplanstatus_no === '10'">
        <div class="col-xs-12 sp-0">
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="previousButton"></ng-container>

                <tt-input-number
                    ttLabelView="top"
                    ttLabel="stock_quantity_pre_optimalization"
                    [(ttModel)]="get.stock_quantity_pre_optimalization"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                ></tt-input-number>
                <tt-input ttLabelView="top" ttLabel="stock_unit_name" [(ttModel)]="get.stock_unit_name" ttReadonly></tt-input>
                <tt-input ttLabelView="top" ttLabel="pohcompletionprinciple_name" [ttModel]="get.pohcompletionprinciple_name" ttReadonly></tt-input>
            </tt-card>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="nextButton"></ng-container>

                <tt-input-number
                    ttLabelView="top"
                    ttLabel="pcs_to_pick_after_optimalization"
                    [(ttModel)]="get.quantity_to_pick"
                    (ttModelChange)="onChange('quantity_to_pick')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                ></tt-input-number>
                <tt-input-number
                    ttLabelView="top"
                    ttLabel="stock_quantity_after_optimalization"
                    [(ttModel)]="get.stock_quantity_after_optimalization"
                    (ttModelChange)="onChange('stock_quantity_after_optimalization')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    ttReadonly
                ></tt-input-number>
                <tt-input-number
                    ttLabelView="top"
                    ttLabel="workingtime_hours"
                    [(ttModel)]="get.workingtime_hours"
                    (ttModelChange)="onChange('workingtime_hours')"
                    ttTextAlign="right"
                    ttDecimals="2"
                    [ttReadonly]="get.cuttingplanstatus_no !== '30'"
                ></tt-input-number>
                <!-- <tt-button *ngIf="+get.cuttingplanstatus_no >= 20" ttText="cuttingplan_print" (ttClick)="print()" [ttLoading]="printing" ttIcon="far fa-print"></tt-button> -->
                <tt-button *ngIf="get.cuttingplanstatus_no === '20'" ttText="cuttingplan_to_optimalization" ttIcon="fas fa-sync-alt" (ttClick)="optimalize()" [ttLoading]="optimalizing"></tt-button>
                <tt-button *ngIf="get.show_pick === '1'" ttText="cuttingplan_real_consumption" (ttClick)="openRealConsumptionDialog()" [ttLoading]="handlingRealConsumption"></tt-button>
                <tt-button *ngIf="get.show_reset_pick === '1'" ttText="cuttingplan_reset_pick" ttType="danger" (ttClick)="resetPick()" [ttLoading]="resettingPick"></tt-button>
                <tt-button *ngIf="get.cuttingplanstatus_no === '50'" ttText="cuttinplan_finish" ttType="success" (ttClick)="finish()" [ttLoading]="finishing"></tt-button>
                <!-- <tt-button ttText="cuttingplan_distribute" ttIcon="fas fa-sync-alt" (ttClick)="distribute()" [ttLoading]="distributing"></tt-button> -->
            </tt-card>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <ng-container [ngTemplateOutlet]="gotoStockButton"></ng-container>
            </tt-card>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <tt-select
                    *ngIf="+get.cuttingplanstatus_no >= 20"
                    ttLabelView="top"
                    ttLabel="printer"
                    [(ttModel)]="$any(get).printer_keyno"
                    [ttData]="printers"
                    ttDataId="printClientPrinterKeyno"
                    ttDataName="name"
                >
                    <tt-form-field-button buttons ttIcon="fas fa-print" (ttClick)="print()" ttTooltip="cuttingplan_print" [ttTranslateTooltip]="true"></tt-form-field-button>
                </tt-select>
            </tt-card>
            <tt-grid class="col-xs-12 p-2 col-md-6" *ngIf="!!plansGrid" [(ttOptions)]="plansGrid"></tt-grid>

            <!-- <div class="col-xs-12 p-2 col-md-3"></div>
            <tt-card class="col-xs-12 p-2 col-md-3">
                <tt-select
                    ttLabelView="top"
                    ttLabel="cuttingplanstatus"
                    [(ttModel)]="get.cuttingplanstatus_no"
                    (ttModelChange)="onChange('cuttingplanstatus_no')"
                    [ttData]="statuses"
                    ttDataId="item_id"
                    ttDataName="item_name"
                ></tt-select>
            </tt-card> -->
        </div>
        <tt-grid *ngIf="!!poGrid" [(ttOptions)]="poGrid"></tt-grid>
        <tt-grid *ngIf="!!compGrid" [(ttOptions)]="compGrid"></tt-grid>
        <tt-card *ngIf="get.show_setting === '1'">
            <tt-button-settings></tt-button-settings>
        </tt-card>
    </div>
</ng-container>

<ng-template #button> </ng-template>

<ng-template #nextButton>
    <ng-container *ngIf="!!get">
        <tt-button
            ttText="cuttingplan_next"
            (ttClick)="nextStep()"
            [ttLoading]="steppingNext"
            [ttDisabled]="
                '' + get.cuttingplanstatus_no === '60' ||
                steppingPrevious ||
                ('' + get.cuttingplanstatus_no === '30' && +get.stock_quantity_after_optimalization === 0) ||
                '' + get.cuttingplanstatus_no === '50'
            "
        ></tt-button>
    </ng-container>
    <!-- [ttDisabled]="'' + get.cuttingplanstatus_no === '60' || steppingPrevious" -->
</ng-template>

<ng-template #previousButton>
    <ng-container *ngIf="!!get">
        <tt-button
            ttText="cuttingplan_previous"
            ttType="secondary"
            (ttClick)="previousStep()"
            [ttLoading]="steppingPrevious"
            [ttDisabled]="'' + get.cuttingplanstatus_no === '10' || steppingNext || '' + get.cuttingplanstatus_no === '60'"
        ></tt-button>
    </ng-container>
</ng-template>

<ng-template #gotoStockButton>
    <ng-container *ngIf="!!get">
        <tt-input-number
            ttLabelView="top"
            ttLabel="stock_stockvalue_ex_assigned"
            [(ttModel)]="get.stock_stockvalue_ex_assigned"
            (ttModelChange)="onChange('stock_stockvalue_ex_assigned')"
            ttTextAlign="right"
            ttDecimals="2"
            ttReadonly
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-chevron-right" ttGoto="stockget" [ttGotoParms]="{ stock_keyno: '' + get.stock_keyno }"></tt-form-field-button>
            </ng-container>
        </tt-input-number>
    </ng-container>
</ng-template>
